/* global window */
export default (config, log) => ({
  handle(status) {
    switch (status) {
      case 401:
        this.redirect(config.loginUrl);
        break;

      case 403:
        this.disconnectAlert(
          config.home,
          config.i18n.auth403title,
          config.i18n.auth403message,
        );
        break;

      case 500:
        this.disconnectAlert(
          config.home,
          config.i18n.auth500title,
          config.i18n.auth500message,
        );
        break;
      default:
        log('Unknown error code received: ', status, ' - doing nothing');
    }
  },
  disconnectAlert(redirectUrl, title, message) {
    log('Disconnect alert: ', redirectUrl, title, message);

    var fullMessage = 'Unexpected error ocurred. Disconnected';
    if (title && message && title !== 'undefined' && message !== 'undefined') {
      fullMessage = `${title}\n\n${message}`;
    }
    alert(fullMessage);
    this.redirect(redirectUrl);
  },
  redirect(redirectUrl) {
    top.location.href = redirectUrl;
  },
});



/** WEBPACK FOOTER **
 ** ./src/handler.js
 **/